import { IHttpService, IPromise } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { IUpdateItemLinks } from "@webapp/links/models/links-api.models";
import { BulkLink, ICanLinkInfo, Link, Links, LinksDTO } from "@webapp/links/models/links.models";

export class LinkService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public unlink(link: LinksDTO<Link>): IPromise<void> {
    const { sourceType, sourceId, linkType, targetType, targetId } = link;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/${linkType}/${targetType}/${targetId}`);

    return this.$http.delete<boolean>(url).then(() => null);
  }

  public link(link: LinksDTO<Link>): IPromise<void> {
    const { sourceType, sourceId, linkType, targetType, targetId } = link;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/${linkType}/${targetType}/${targetId}`);

    return this.$http.post<void>(url, null).then((response) => response.data);
  }

  public bulkLink(args: BulkLink & { body: Links<"metric">; shouldSkipDueDatesUpdates: boolean }): IPromise<void> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}?shouldSkipDueDatesUpdates=${args.shouldSkipDueDatesUpdates}`);

    return this.$http.post<void>(url, body).then((response) => response.data);
  }

  public patchLinks(args: BulkLink & { body: IUpdateItemLinks; shouldSkipDueDatesUpdates: boolean }): IPromise<void> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}?shouldSkipDueDatesUpdates=${args.shouldSkipDueDatesUpdates}`);

    return this.$http.patch<void>(url, body).then((response) => response.data);
  }

  public checkIfCanLink(args: BulkLink & { body: Links<"metric"> }): IPromise<ICanLinkInfo> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/can-link-info`);

    return this.$http.post<ICanLinkInfo>(url, body).then((response) => response.data);
  }
}
